// BottomNavigationBar.tsx
import React from 'react';
import {View, TouchableOpacity, Text, StyleSheet} from 'react-native';
import Icon from '@react-native-vector-icons/fontawesome';
import {RootState} from '../redux/store';
import {useSelector} from 'react-redux';

import T from '../Components/T';
const BottomNavigationBar = ({navigation, navigationRef}: any) => {
  const gdata = useSelector((state: RootState) => state.gdata);

  const navigateTo = (screen: string) => {
    const nav =
      navigation && typeof navigation.navigate === 'function'
        ? navigation
        : navigation?.current && typeof navigation.current.navigate === 'function'
        ? navigation.current
        : navigationRef?.current && typeof navigationRef.current.navigate === 'function'
        ? navigationRef.current
        : null;

    if (nav) {
      nav.navigate(screen);
    } else {
      console.warn('Navigation not ready for screen:', screen);
    }
  };

  return (
    <View style={styles.container}>
      {gdata?.menu?.some((v: any) => v.mn_link === '/status/status') && (
        <TouchableOpacity onPress={() => navigateTo('Dashboard')}>
          <Icon style={styles.icon} name="home" size={24} />
          <Text style={styles.label}><T>Home</T></Text>
        </TouchableOpacity>
      )}

      {gdata?.menu?.some((v: any) => v.mn_link === '/status/status') && (
        <TouchableOpacity onPress={() => navigateTo('StatusScreen')}>
          <Icon style={styles.icon} name="bed" size={24} />
          <Text style={styles.label}><T>Status</T></Text>
        </TouchableOpacity>
      )}

      {gdata?.menu?.some((v: any) => v.mn_link === '/status/status') && (
        <TouchableOpacity
          onPress={() => navigateTo('RoomAvailability')}>
          <Icon style={styles.icon} name="building" size={24} />
          <Text style={styles.label}><T>Availability</T></Text>
        </TouchableOpacity>
      )}

      {gdata?.menu?.some((v: any) => v.mn_link === '/status/status') && (
        <TouchableOpacity onPress={() => navigateTo('InHouse')}>
          <Icon style={styles.icon} name="users" size={24} />
          <Text style={styles.label}><T>In-house</T></Text>
        </TouchableOpacity>
      )}

      {gdata?.menu?.some(
        (v: any) => v.mn_link === '/transaction/potablelist',
      ) && (
        <TouchableOpacity onPress={() => navigateTo('Home')}>
          <Icon style={styles.icon} name="user" size={24} />
          <Text style={styles.label}><T>POS</T></Text>
        </TouchableOpacity>
      )}

      {gdata?.menu?.some(
        (v: any) =>
          v.mn_link === '/transaction/fohousekeeping' ||
          v.mn_link === '/status/hkstatus' ||
          v.mn_link === '/transaction/publiccleaning' ||
          v.mn_link === '/masters/hkpublicplace',
      ) && (
        <TouchableOpacity onPress={() => navigateTo('HouseKeeping')}>
          <Icon style={styles.icon} name="paint-brush" size={24} />
          <Text style={styles.label}><T>Housekeeping</T></Text>
        </TouchableOpacity>
      )}

      {gdata?.menu?.some(
        (v: any) =>
          v.mn_link?.includes('/am') ||
          v.mn_link?.includes('am-') ||
          v.mn_link === '/masters/am-categories' ||
          v.mn_link === '/transaction/am-assets',
      ) && (
        <TouchableOpacity onPress={() => navigateTo('AssetHome')}>
          <Icon style={styles.icon} name="archive" size={24} />
          <Text style={styles.label}><T>Assets</T></Text>
        </TouchableOpacity>
      )}

      {!gdata?.menu?.some((v: any) => v.mn_link === '/status/status') && (
        <>
          {gdata?.menu?.some(
            (v: any) => v.mn_link === '/transaction/potablelist',
          ) && (
            <TouchableOpacity
              onPress={() => navigateTo('ChangeTable')}>
              <Icon style={styles.icon} name="refresh" size={24} />
              <Text style={styles.label}><T>Change Table</T></Text>
            </TouchableOpacity>
          )}
          {gdata?.menu?.some(
            (v: any) => v.mn_link === '/transaction/potablelist',
          ) && (
            <TouchableOpacity
              onPress={() => navigateTo('RunningOrders')}>
              <Icon style={styles.icon} name="clock-o" size={24} />
              <Text style={styles.label}><T>Running Orders</T></Text>
            </TouchableOpacity>
          )}
          {gdata?.menu?.some(
            (v: any) => v.mn_link === '/transaction/potablelist',
          ) && (
            <TouchableOpacity onPress={() => navigateTo('Settlement')}>
              <Icon style={styles.icon} name="money" size={24} />
              <Text style={styles.label}><T>Settlement</T></Text>
            </TouchableOpacity>
          )}
        </>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: 60,
    width: '100%',
    backgroundColor: '#f5f5f5',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#ccc',
    zIndex: 20,
  },
  label: {
    fontSize: 12,
    textAlign: 'center',
  },
  icon: {
    textAlign: 'center',
  },
});

export default BottomNavigationBar;

